export default __webpack_public_path__ + "static/media/Page28.2da0b7e0.txt";